import { AppThunk } from '€slices/types';
import { callApi } from '€slices/network';
import api from '€api/client';
import { actions } from './applications-slice';
import { BrokerApplicationsResponse } from 'signature-public-api-sdk';

export const fethApplications = (): AppThunk => async dispatch => {
    const [error, response] = await dispatch(
        callApi<BrokerApplicationsResponse>(api.BrokerPortal.Applications.list({ page: 1 })),
    );

    if (error) {
        dispatch(actions.receiveDataFailure());
    } else {
        dispatch(actions.receiveDataSuccess(response));
    }
};
